import styles from "./index.module.scss"
import Select from "../../../../../../atoms/Select"
import intl from "react-intl-universal"
import Input from "../../../../../../atoms/Input"
import Label from "../../../../../../atoms/Label"

export const ReportFilters = ({
  equipments,
  analytes,
  startDate,
  endDate,
  validateDate,
  setStatus,
  setOAnalyteSelected,
  oAnalyteSelected,
  setOEquipmentSelected,
  oEquipmentSelected,
  setStartDate,
  setEndDate,
  isLoadingAnalyte,
}) => {
  const options = [
    {
      label: intl.get("ciq.list_analytes.all"),
      value: 2,
    },
    {
      label: intl.get("ciq.list_analytes.active"),
      value: 1,
    },
    {
      label: intl.get("ciq.list_analytes.inactive"),
      value: 0,
    },
  ]

  return (
    <div className={styles.wrapperFIlter}>
      <div className={`${styles.itemFlex}`}>
        <Select
          id="ciq-report-filter-equipment"
          label={intl.get("ciq.filter_by_equipments")}
          placeholder={
            !oEquipmentSelected?.length
              ? intl.get("ciq.release_details.date_filters.selected_all")
              : null
          }
          width="100%"
          searchable={true}
          multiSelect={true}
          value={oEquipmentSelected}
          options={equipments}
          onSelect={(e) => {
            setOEquipmentSelected(e || [])
          }}
        />
      </div>
      <div className={`${styles.itemFlex}`}>
        <Select
          id="ciq-report-filter-analyte"
          bIsDisabled={isLoadingAnalyte}
          label={intl.get("ciq.filter_by_analyte")}
          placeholder={
            isLoadingAnalyte
              ? intl.get("ciq.loading_analytes")
              : !oAnalyteSelected?.length
              ? intl.get("ciq.release_details.date_filters.selected_all")
              : null
          }
          searchable={true}
          multiSelect={true}
          onSelect={(e) => {
            setOAnalyteSelected(e || [])
          }}
          vlaue={oAnalyteSelected}
          options={analytes}
        />
      </div>
      <div className={`${styles.itemFlex} ${styles.statusField}`}>
        <Select
          className={styles.select}
          label={intl.get("ciq.analyte_status")}
          width="100%"
          options={options}
          defaultValue={options[0]}
          searchable={false}
          placeholder={intl.get("selection")}
          onSelect={(itemSelected) => {
            if (itemSelected.value === 2) {
              setStatus(null)
              return
            }
            setStatus(itemSelected)
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          alignContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
          minWidth: 400,
          gap: 4,
          marginTop: -19,
        }}
      >
        <Label>{intl.get("ciq.launch_period")}</Label>
        <div
          style={{
            display: "flex",
            alignContent: "center",
            alignItems: "center",
            flexDirection: "row",
            gap: "1rem",
            width: "100%",
          }}
        >
          <div className={`${styles.itemFlex}`}>
            <Input
              width="100%"
              label={intl.get("ciq.start_date")}
              type="date"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value)
              }}
            />
          </div>
          <div className={`${styles.itemFlex}`}>
            <Input
              width="100%"
              label={intl.get("ciq.end_date")}
              type="date"
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value)
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
